import { useAppContext } from '@/context/app'
import { Machine } from '@/services/model/machine'
import React from 'react'

export interface MachineNameData  {
  internalNumber: string | undefined
  type: {
    manufacturer: string;
    category: string;
    model: string;
  }
}

export function MachineName(props: {
    row: MachineNameData
}) {
    const { row } = props
    const { translates } = useAppContext()
    return [
      row.type.manufacturer,
      row.type.category ? translates?.for(`machine.types.${row.type.category}`) : null,
      row.type.model,
      row.internalNumber,
    ].filter(val => val != null && val !== '').join(' > ')
}